import React from "react";
import {} from "react-bootstrap";

const Skills = () => {
  return (
    <section className="section" id="skills">
      <div className="container mx-auto ">
        <h1>Privacy Policy for Rkado Nepal </h1>
        <p>Effective Date: [Februray 21, 2020]</p>
        <h2>1. Introduction</h2>
        <p>
          Welcome to Rkado Nepal! We are deeply committed to safeguarding your
          privacy and ensuring that your personal data is treated with the
          utmost care, transparency, and respect. This Privacy Policy is
          designed to provide you with clear insights into how we collect, use,
          protect, and share your personal information when you use our app.
        </p>
        <br />
        <br />
        <h2>2. Information We Collect</h2>
        <h3>2.1. Registration Information:</h3>{" "}
        <p>
          When you create an account, we may collect your username, email
          address, and password. This information is vital to ensure your
          account's security and accessibility.
        </p>
        <h3>2.2. Profile Information:</h3>{" "}
        <p>
          {" "}
          You have the option to provide additional information such as a
          profile picture and display name. We use this information to
          personalize your experience and strengthen your connections with
          others.
        </p>
        <h3>2.3. Chat and Game Data:</h3>{" "}
        <p>
          Your chat messages and gaming activity are essential to make your
          interactions within the app seamless and engaging. We treat your
          conversations and game scores as private and respect your gaming
          achievements.{" "}
        </p>
        <p>
          ***Note: This app is only fun purposes not for money. You can connect
          friends globally and enjoy chatting and games.***
        </p>
        <h3>2.4. Device Information:</h3>{" "}
        <p>
          We automatically collect information about the device you use to
          access our app, including device type, operating system, and unique
          identifiers. This helps us optimize your app experience.
        </p>
        <h3>2.5. Usage Data:</h3>{" "}
        <p>
          We collect information about how you use our app, including the
          features you interact with and the duration of your sessions. This
          data is pivotal in improving our app's performance and content,
          ensuring you have the best experience possible.
        </p>
        <br /> <br />
        <h2>3. How We Use Your Information</h2>
        <h3>3.1. Enhanced User Experience: </h3>
        <p>
          We use your information to enhance your user experience, including
          personalizing content, recommendations, and in-app features. This
          allows us to tailor the app to your preferences and enrich your
          interactions.
        </p>
        <h3>3.2. Transparent Communication: </h3>
        <p>
          We may send you notifications, updates, and service-related messages,
          and we do so transparently, ensuring you have control over the types
          of communications you receive and their frequency.
        </p>
        <h3>3.3. Continuous Improvement: </h3>
        <p>
          We analyze user data to improve our app's performance, features, and
          content, always with the goal of making the app better for you.
        </p>
        <h3>3.4. Legal Compliance: </h3>
        <p>
          We may use your information to comply with legal obligations, such as
          responding to legal requests, but we will always do so transparently
          and within the framework of applicable laws and regulations.
        </p>
        <br /> <br />
        <h2>4. Sharing Your Information</h2>
        <h3>4.1. Third Parties:</h3>{" "}
        <p>
          We may share your information with trusted third-party service
          providers who assist us in delivering our services, but we will never
          sell your data to third parties. We are committed to maintaining your
          privacy and data security in all partnerships.
        </p>
        <h3>4.2. Legal Requirements:</h3>{" "}
        <p>
          We may disclose your information if required by law or to protect our
          rights, privacy, safety, or property, but we will always act
          transparently and within legal boundaries.
        </p>
        <br />
        <br />
        <h2>5. Security</h2>
        <p>
          We employ industry-standard security measures to protect your data and
          privacy. However, it's important to note that while we take every
          precaution to secure your information, no method of transmission over
          the internet or electronic storage is entirely secure, and we cannot
          guarantee absolute security. Rest assured, we are constantly working
          to enhance security.
        </p>
        <br />
        <br />
        <h2>6. Your Choices</h2>
        <p>
          You have the right to access, update, or delete your personal
          information. You can also opt out of certain communications. We
          empower you to have control over your data and interactions within the
          app.
        </p>
        <br />
        <br />
        <h2>7. Children's Privacy</h2>
        <p>
          Our app is not intended for use by individuals under the age of 16. We
          do not knowingly collect information from children under 16. If you
          believe a child's data has been inadvertently collected, please
          contact us at "info@rkado.com" so we can address the issue
          transparently and promptly.
        </p>
        <br />
        <br />
        <h2>8. Changes to this Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes
          in our practices or for other operational, legal, or regulatory
          reasons. We will notify you of any material changes through the app or
          via email, ensuring full transparency about our evolving policies.
        </p>
        <br />
        <br />
        <h2>9. Time Duration and Level Up Methods</h2>
        <h3>9.1. Time Duration:</h3>
        <p>
          Some in-app features and rewards may be influenced by time duration,
          such as daily bonuses and time-limited events. We use this data
          transparently to enhance your gaming experience and offer timely
          rewards.
        </p>
        <h3>9.2. Level Up Methods:</h3>
        <p>
          As you progress within our app, you may unlock new features and
          capabilities. Your level and the methods for leveling up are explained
          clearly within the app to ensure you understand and enjoy the app to
          the fullest.
        </p>
        <br /> <br />
        <h2>10. Earning Free Coins as Rewards</h2>
        <h3>10.1. Rewards:</h3>
        <p>
          We offer opportunities to earn free coins as rewards for various
          in-app activities. These may include daily logins, completing
          challenges, or participating in events. We provide clear guidelines on
          how to earn these rewards, ensuring transparency in the process.
        </p>
        <h2>11. Contact Us</h2>
        <p>
          If you have any questions or concerns about our Privacy Policy, please
          contact us at info@rkado.com . We are always here to address your
          inquiries and maintain an open channel of communication.
        </p>
      </div>
    </section>
  );
};

export default Skills;
